import {Box, CardContent, CircularProgress, Collapse, Grid, Link, TextField, Typography} from "@material-ui/core";
import React, {useState} from "react";
import {makeStyles} from "@material-ui/styles";
import {formatDate, formatDateUS, humanizeMonths} from '../../../../helpers/utils';
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import EducationHistoryFields from "../acordionFields/EducationHistoryFields";
import DatePickerInput from "../../sharedFormComponents/DatePickerInput";
const useStyles = makeStyles((theme) => ({
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {

  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  field: {
    '& label.Mui-focused': {
      color: '#000',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#000',
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#000',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#000',
      },
    },
  },
  addNewRelationshipLink: {
    textTransform: 'capitalize',
    textDecoration: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '16px',
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'none',
    }
  },
}));
const IndustryTenure = (props) => {
  const classes = useStyles();
  const {industryTenure, handleTabChange, tab} = props;

  return (
    <div className={classes.contentSection}>
      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, 0)}>
        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === 2 ? classes.tabActive : ''}`}>Industry Tenure</Typography>
        {tab === 0 ? <ExpandLess /> : <ExpandMore />}
      </div>
      <Collapse in={tab === 0}>
        <div className={classes.contentSectionContent}>
          <div className={classes.formGroup}>
            <Grid container spacing={3} >
              <Grid item md={4} xs={12}>
                <Box>
                  <span>Start: {formatDateUS(industryTenure.start)} ({industryTenure.industry_tenure})</span>
                </Box>
              </Grid>
            </Grid>
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default IndustryTenure;